import {
  ApeironPagingDataGridRef,
  ApeironTitle,
  DataGridProvider
} from '@apeiron/temp'
import { Box, styled } from '@mui/material'
import RewardSecNavBar from '@src/components/navigationBar/secondary/RewardSecNavBar'
import VestingHistorySection from '@src/components/reward/vesting/VestingHistorySection'
import VestingSummaryCard from '@src/components/reward/vesting/VestingSummaryCard'
import { useSecondaryNavBarContext } from '@src/contexts/share/SecondaryNavBarContext'
import { t } from 'i18next'
import { NextPage } from 'next'
import { useEffect, useRef } from 'react'

const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: 40px auto;
  max-width: 1150px;
  width: 100%;
  ${props => props.theme.breakpoints.up('res1024')} {
    padding: 0px 40px;
  }
  ${props => props.theme.breakpoints.down('res1024')} {
    padding: 0px 16px;
  }
`

const VestingPage: NextPage<Props> = () => {
  const { setupBar } = useSecondaryNavBarContext()

  const gridRef = useRef<ApeironPagingDataGridRef>(null)

  useEffect(() => {
    setupBar(<RewardSecNavBar index={1} />)

    return () => setupBar(null)
  }, [setupBar])

  return (
    <Container>
      <ApeironTitle text={t('vesting.my_vesting')} />
      <VestingSummaryCard gridRef={gridRef} />
      <DataGridProvider>
        <VestingHistorySection gridRef={gridRef} />
      </DataGridProvider>
    </Container>
  )
}

type Props = {}

export default VestingPage
